import * as React from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'

const Navigation = ({ children }) => {
  const data = useStaticQuery(graphql`
    query CombinedDataQuery {
      site {
        siteMetadata {
          title
        }
      }
      navigationYaml {
        navigation_items {
          name
          path
          items {
            name
            path
          }
        }
      }
    }
  `);

  const siteTitle = data.site.siteMetadata.title;
  const navigationItems = data.navigationYaml?.navigation_items || [];
      const menuStyle = "scale-100 text-white border-white hover:border-b-2"
    return (
        <div className="bg-brand-dark">
<div className="mx-auto max-w-7xl flex text-white">
<header className="p-4 font-bold transition-all hover:scale-110"><Link className={menuStyle} to="/">{siteTitle}</Link></header>
<nav>
<ul className="flex pl-8 p-4 space-x-4">
  {navigationItems.map((item) => (
    <li className="transition-all hover:scale-110" key={item.path}>
      <Link className={menuStyle} to={item.path}>{item.name}</Link>
      {item.items && (
        <ul>
          {item.items.map((subItem) => (
            <li key={subItem.path}>
              <Link to={subItem.path}>{subItem.name}</Link>
            </li>
          ))}
        </ul>
      )}
    </li>
  ))}
</ul>
</nav>
  </div>
    </div>
    )
}

export default Navigation

